export default __webpack_public_path__ + "static/media/card3.68ac42a3.png";